<dt-modal-content (closeClick)="closeModal()" [showX]="true" [flexContent]="true" [contentPadding]="false">
  <ng-template #title i18n>Projektverwaltung</ng-template>
  <ng-template #content>
    <div
      class="content-container"
      [dtWidthTrigger]="{ vertical: 480 }"
      (dragenter)="dragEnter()"
      (dragleave)="dragLeave()"
      (drop)="drop($event)"
      (dragover)="dragOver($event)"
    >
      @if (showDragArea) {
        <div class="drag-area" i18n>Lege eine Projektdatei hier ab, um sie zu laden</div>
      }
      <div class="actions">
        @if (isOffline) {
          <mat-error class="dt-error" i18n>Du bist offline. Einige Funktionen stehen nicht zur Verfügung.</mat-error>
        }
        <div class="action" matRipple (click)="newProject()">
          <mat-icon>add_circle_outline</mat-icon>
          <div i18n>Neues Projekt erstellen</div>
        </div>
        <div
          class="action"
          matRipple
          [class.disabled]="!isLoggedIn || isOffline || onlineProjects == null || teamProjects == null || projectFolders == null"
          i18n-matTooltip
          matTooltip="Du musst eingeloggt sein, um Projekte in Deinem Benutzerkonto verwalten zu können."
          [matTooltipDisabled]="isLoggedIn"
          [matTooltipShowDelay]="1000"
          matTooltipPosition="before"
          (click)="loadUserProject()"
          [dtOverlayProgress]="isLoggedIn && (onlineProjects == null || teamProjects == null) && !isOffline"
          data-cy="online-projects-button"
        >
          <mat-icon>cloud_download</mat-icon>
          <div i18n>Meine Projekte</div>
        </div>
        <div
          class="action"
          matRipple
          (click)="loadQuickstartProject()"
          [dtHoverPopover]="quickstartDescription"
          [dtHoverPopoverPosition]="'right'"
          [dtHoverPopoverDisableClick]="true"
          [class.disabled]="isOffline || quickstartProjects == null || quickstartTags == null"
          [dtOverlayProgress]="quickstartProjects == null && !isOffline"
        >
          <mat-icon>archive</mat-icon>
          <div class="text">
            <div i18n>Beispiele und Templates öffnen</div>
          </div>
          <ng-template #quickstartDescription>
            <div class="description-popover mat-elevation-z4" i18n
              >Nutze die Themenprojekte, um den Prozess des reflektierten Entscheidens anhand von fertig ausgefüllten Projekten
              kennenzulernen. Wir bieten Dir hier viele verschiedene Beispiele für Entscheidungsprobleme mit Erklärungen und Kommentaren.
              Mit diesen Beispielen kannst Du das Entscheidungsnavi auch ganz ohne eigene Entscheidungsfrage erkunden.</div
            >
          </ng-template>
        </div>
        <div class="action" matRipple (click)="projectFileInput.click()">
          <mat-icon>file_upload</mat-icon>
          <div i18n>Projekt importieren</div>
          <input
            #projectFileInput
            class="project-file-input"
            type="file"
            accept=".json"
            (change)="projectInputChange(projectFileInput)"
            data-cy="project_file_input"
          />
        </div>
        <mat-divider></mat-divider>
        <div
          class="action"
          matRipple
          (click)="save()"
          [class.disabled]="!isProjectLoaded() || !isLoggedIn || isOffline"
          i18n-matTooltip
          matTooltip="Du musst eingeloggt sein, um Projekte in Deinem Benutzerkonto speichern zu können."
          [matTooltipDisabled]="isLoggedIn"
          [matTooltipShowDelay]="1000"
          matTooltipPosition="before"
          data-cy="save-as-button"
        >
          <mat-icon>save</mat-icon>
          <div i18n>Projekt speichern unter</div>
        </div>
        <div class="action" matRipple [class.disabled]="!isProjectLoaded()" [matMenuTriggerFor]="more" data-cy="export-project-button">
          <mat-icon>file_download</mat-icon>
          <div i18n>Projekt exportieren</div>

          <mat-menu #more>
            <button mat-menu-item (click)="exportProject('json')" [disabled]="!isProjectLoaded()" data-cy="export-json-button">
              <mat-icon>file_download</mat-icon>
              <span i18n>Projektdatei herunterladen</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="exportProject('pdf')" [disabled]="!isProjectLoaded()" data-cy="export-pdf-button">
              <mat-icon>summarize</mat-icon>
              <span i18n>PDF-Report erzeugen</span>
            </button>
            <button mat-menu-item (click)="exportProject('excel')" [disabled]="!isProjectLoaded()" data-cy="export-excel-button">
              <mat-icon>table_view</mat-icon>
              <span i18n>Als Excel exportieren</span>
            </button>
          </mat-menu>
        </div>
        <div
          class="action"
          (click)="closeProject()"
          matRipple
          [class.disabled]="!isProjectLoaded()"
          i18n-matTooltip
          matTooltip="Du hast aktuell kein Projekt geöffnet."
          [matTooltipDisabled]="isProjectLoaded()"
          [matTooltipShowDelay]="1000"
          matTooltipPosition="before"
          data-cy="close-project-button"
        >
          <mat-icon>close</mat-icon>
          <div i18n>Projekt schließen</div>
        </div>
        <ng-container *dtProjectMode="'professional'">
          <mat-divider></mat-divider>

          <div class="action" matRipple (click)="feedback()">
            <mat-icon>rate_review</mat-icon>
            <div i18n>Feedback geben</div>
          </div>
        </ng-container>
      </div>
      @if (isLoggedIn) {
        <div class="recently-edited">
          <div class="header" i18n>Zuletzt bearbeitete Projekte</div>
          @if (getOnlineAndTeamProjects() != null) {
            <dt-recently-edited-projects
              [projects]="getOnlineAndTeamProjects()"
              (projectLoaded)="closeModal()"
            ></dt-recently-edited-projects>
          } @else if (!isOffline) {
            <mat-spinner [diameter]="36"></mat-spinner>
          }
        </div>
      }
    </div>
  </ng-template>
</dt-modal-content>
